import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthorizationBase } from 'src/app/shared/libraries/authorize-base';
import { CustomerAddressFormComponent } from '../customer-address-form/customer-address-form.component';
import { HeartlandCardTokenizerComponent } from '../../../../shared/components/heartland-card-tokenizer/heartland-card-tokenizer.component';
import { CustomerCardNumber } from '../../../models/customer.model';
import {
  CardInfo,
  CreditPayment,
  CustomerAddress,
} from '../../../models/invoice/invoice.model';
import { AlertService } from '../../../../core/alert.service';
import { CreditPaymentService } from '../../../services/creditpayment.service';
import { CustomerManagementService } from '../../../services/customer.service';
import { SourceComponent } from '../../../models/invoice/payment.model';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';

@Component({
  selector: 'app-customercarddata-form',
  templateUrl: './customercarddata-form.component.html',
  styleUrls: ['./customercarddata-form.component.scss'],
})
export class CustomerCardDataComponent
  extends AuthorizationBase
  implements OnInit
{
  @ViewChild('container', { static: false }) tcpTemplate: TemplateRef<any>;
  @ViewChild('tokenizerForm', { static: false })
  tokenizerForm: HeartlandCardTokenizerComponent;

  @Input() customercardData: any;
  @Input() customerId: number;
  @Input() addressId: number = 0;
  @Input() policyContent: string;
  @Input() termsAndConditionContent: string;
  tokenReceived: boolean = false;
  formTitle: string = 'Add Customer Card';
  buttonTitle: string = 'Add new customer card';
  isUpdate: boolean = false;
  maskedcardnumber: string;
  busy: boolean = false;
  model: CustomerCardNumber;
  cardToken: any;
  cardBrandTransactionId: string;

  docSource = 'customerMgt';

  verifyMessage: string = 'Card not yet verified';

  customerAddress: CustomerAddress;
  customerAddressList: any[];

  tcpTitle: string;
  tcpContent: string;

  currentModal: NgbModalRef;

  processor: string;

  cardDataSource: 'internet';

  @AutoUnsubscribe()
  private getCustomerAddresses$: Subscription;
  @AutoUnsubscribe()
  private getCustomerCardNumber$: Subscription;
  @AutoUnsubscribe()
  private updateCustomerCardNumber$: Subscription;
  @AutoUnsubscribe()
  private addCustomerCardNumber$: Subscription;
  @AutoUnsubscribe()
  private creditVerify$: Subscription;

  constructor(
    private modalRef: NgbActiveModal,
    private alert: AlertService,
    private creditService: CreditPaymentService,
    public apiService: CustomerManagementService,
    private modalService: NgbModal
  ) {
    super();
    this.model = new CustomerCardNumber();
    this.processor = super.getPlatform().toString();
  }

  ngOnInit() {
    if (this.customercardData) {
      this.getCustomerCardData(this.customercardData.id);
      this.formTitle = 'Update Customer Card';
      this.buttonTitle = 'Update customer card';
      this.isUpdate = true;
      this.maskcreditcard(this.customercardData.cardNumber);
    } else {
      this.customercardData = new CustomerCardNumber();
      this.customercardData.id = 0;
      this.customercardData.customerId = this.customerId;
      this.model = this.customercardData;
    }

    this.customerAddress = new CustomerAddress();
    this.getCustomerAddress(this.customerId);
  }

  getCustomerAddress(id: number) {
    this.busy = true;
    this.getCustomerAddresses$ = this.apiService
      .getCustomerAddresses(id)
      .subscribe(
        (res: any) => {
          if (res) {
            let addr = res.find((addr) => {
              if (this.addressId != 0) {
                return addr.Id === this.addressId;
              } else {
                return addr.IsDefault === true;
              }
            });
            this.customerAddressList = res;

            if (addr) {
              this.addressId = addr.Id;
              this.customerAddress.City = addr.City;
              this.customerAddress.State = addr.State;
              this.customerAddress.PostalCode = addr.ZipCode;
              this.customerAddress.StreetAddress1 = addr.StreetAddress;
            }
          }
        },
        (error: any) => {},
        () => {
          this.busy = false;
        }
      );
  }

  getCustomerCardData(id: number) {
    this.busy = true;
    this.getCustomerCardNumber$ = this.apiService
      .getCustomerCardNumber(id)
      .subscribe(
        (res: any) => {
          if (res) {
            this.model = res;
          }
        },
        (error: any) => {},
        () => {
          this.busy = false;
        }
      );
  }

  onCardTokenReceived(token) {
    this.cardToken = token;
    this.tokenReceived = true;
    // call verify
    let creditCard = new CreditPayment();
    creditCard.cardInfo = new CardInfo();
    creditCard.cardInfo.token = this.cardToken.paymentReference;
    creditCard.cardInfo.number = this.cardToken.details.cardLast4;
    creditCard.cardInfo.cardType = this.cardToken.details.cardType;
    creditCard.cardInfo.cardBIN = this.cardToken.details.cardBin;
    creditCard.cardInfo.expMonth = this.cardToken.details.expiryMonth;
    creditCard.cardInfo.expYear = this.cardToken.details.expiryYear;
    creditCard.cardInfo.cvn = this.cardToken.details.cvv;

    creditCard.billingAddress = this.customerAddress;
    creditCard.SourceComponent = SourceComponent.AddCustomerCard;
    creditCard.TransactionSource = SourceComponent.AddCustomerCard;
    creditCard.cardDataSource = this.cardDataSource;
    creditCard.LocationId = +super.getUserLocationId();

    this.creditVerify$ = this.creditService.creditVerify(creditCard).subscribe(
      (res: any) => {
        if (res) {
          this.cardToken.token_value = res.token;
          this.cardBrandTransactionId = res.cardBrandTransactionId;
          this.save();
        }
      },
      (err) => {
        this.alert.alertError({
          title: 'Verification failed',
          text: err.error,
        });
        this.tokenizerForm.setBusyState(false);
        this.busy = false;
      }
    );
  }

  maskcreditcard(cardnumber: string) {
    //mask
    var text = '';
    for (var i = 0; i < cardnumber.length - 4; i++) {
      text += 'X';
    }
    text = text + cardnumber.substring(cardnumber.length - 4);
    this.maskedcardnumber = text;
  }

  save() {
    const id = this.customercardData.id;
    if (id > 0) {
      this.model.IsDeleted = false;
      this.model.UpdatedBy = 1;
      this.model.UpdatedDate = new Date();
      this.updateCustomerCardNumber$ = this.apiService
        .updateCustomerCardNumber(this.model)
        .subscribe((res) => {
          if (res) {
            this.alert.alertSuccess({
              title: 'Success',
              text: 'Successfully updated customer card',
            });
            this.tokenizerForm.setBusyState(false);
            this.modalRef.close(true);
          }
        });
    } else {
      this.model.Token = this.cardToken.token_value;
      this.model.CardLast4Digits = this.cardToken.last_four;
      this.model.CardBrand = this.cardToken.card_type;

      this.model.CardLast4Digits = this.cardToken.details.cardLast4;
      this.model.CardBrand = this.cardToken.details.cardType;
      this.model.ExpMonth = this.cardToken.details.expiryMonth;
      this.model.ExpYear = this.cardToken.details.expiryYear;
      this.model.CVN = this.cardToken.details.cvv;
      this.model.CardBrandTransactionId = this.cardBrandTransactionId;

      this.model.IsDeleted = false;
      this.model.CreatedBy = Number.parseInt(this.userId().toString());
      this.model.CreatedDate = new Date();
      this.model.UpdatedBy = null;
      this.model.UpdatedDate = null;
      this.model.Id = 0;
      this.model.CustomerId = this.customerId;

      this.addCustomerCardNumber$ = this.apiService
        .addCustomerCardNumber(this.model)
        .subscribe((res) => {
          if (res) {
            this.alert.alertSuccess({
              title: 'Success',
              text: 'Successfully created customer card',
            });
            this.tokenizerForm.setBusyState(false);
            this.modalRef.close(true);
          }
        });
    }
  }

  addAddress() {
    let cardDiag = this.modalService.open(CustomerAddressFormComponent, {
      size: 'lg',
    });
    cardDiag.componentInstance.customerId = this.customerId;

    cardDiag.result.then((res: CustomerAddress) => {
      if (res) {
        this.customerAddressList.push(res);
        this.addressId = res.Id;
        this.addressSelected();
      }
    });
  }

  addressSelected() {
    var addr = this.customerAddressList.find((addr) => {
      return addr.Id == this.addressId;
    });
    if (addr) {
      this.customerAddress.City = addr.City;
      this.customerAddress.State = addr.State;
      this.customerAddress.PostalCode = addr.ZipCode;
      this.customerAddress.StreetAddress1 = addr.StreetAddress;
    }
  }

  openTermsAndCondition() {
    this.tcpTitle = 'Terms and Conditions';
    this.tcpContent = this.termsAndConditionContent;
    this.currentModal = this.modalService.open(this.tcpTemplate, {
      size: 'lg',
    });
  }

  openPolicy() {
    this.tcpTitle = 'Policy';
    this.tcpContent = this.policyContent;
    this.currentModal = this.modalService.open(this.tcpTemplate, {
      size: 'lg',
    });
  }

  close() {
    this.modalRef.close();
  }
}
